module.exports = __webpack_public_path__ + "img/1233_1.0dbf27be.jpg";